import { cn } from '@/lib/utils'
import { LogoMark } from './LogoMark'
import { MARK_NAVY, MARK_WHITE } from './markPath'

/**
 * Mark + "FrontFlow" wordmark in Onest, as in the website header
 * (32px mark, 22px wordmark, 10px apart). onDark switches both to white.
 *
 * onDark also tells the mark what it is standing on, which it needs for the ring it knocks out
 * of itself. The dark surfaces in this app are bg-gray-900, which the Tailwind config overrides
 * to the brand navy rather than Tailwind's own near-black.
 */
export function FrontFlowLogo({ onDark = false, className }: { onDark?: boolean; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <LogoMark
        size={32}
        color={onDark ? MARK_WHITE : MARK_NAVY}
        background={onDark ? MARK_NAVY : MARK_WHITE}
      />
      <span
        className={cn('font-brand text-[22px] font-semibold leading-none tracking-[-0.03em]', onDark ? 'text-white' : 'text-gray-900')}
      >
        FrontFlow
      </span>
    </span>
  )
}
